import { formatClockTime, formatDottedDate } from '@noor/lib';
import type { DeliveryOrder, DeliveryStop } from '../model/schema';

/**
 * Format an ISO timestamp as the Доставка table shows it: "10:00, 01.01.2025".
 * Parsing is tolerant — an unparseable value is returned as-is so a bad backend
 * string never blanks the cell.
 */
export function formatDeliveryTimestamp(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return `${formatClockTime(date)}, ${formatDottedDate(date)}`;
}

/** The single pickup stop (the first stop is always the origin). */
export function pickupStop(order: DeliveryOrder): DeliveryStop | undefined {
  return order.stops[0];
}

/** Every dropoff stop, in route order. */
export function dropoffStops(order: DeliveryOrder): DeliveryStop[] {
  return order.stops.slice(1);
}

/** True when the order has more than one dropoff — the row is expandable. */
export function isMultiDrop(order: DeliveryOrder): boolean {
  return dropoffStops(order).length > 1;
}
